///<amd-module name='iFrameDiagnostics'/>

import * as DomHelper from "../Helpers/DomHelper";
import * as BlobHelper from "../Helpers/BlobHelper";
import { DiagnosticStatus } from "../Interfaces/Interfaces";
import { cancel } from "../Helpers/ExecutionStatus";

const global: Window = window;
const { selfHelp: { resources } } = global;
const key = "loadIFrame";
const { statusIconVals } = DomHelper;

let diagnostics: DiagnosticStatus;
let testRan = false;
let iframeDocReadyState: DocumentReadyState;

/** Ends tests. Updates DOM and Blob. Ensures that if tests have been canceled execution stops. */
function endTest(): void {
    if (cancel || testRan) { return; }
    BlobHelper.updateBlob(key, diagnostics);
    const displayStatus = diagnostics.success ? statusIconVals.success : statusIconVals.error;
    DomHelper.displayStatusIcon(key, displayStatus);
    DomHelper.createMoreDetailsSection(key, diagnostics.details);
    DomHelper.makeBarGrow(key);
    testRan = true;
}

/**
 * Checks whether the iframe doc was successfully loaded and
 * updates diagnostic data object with success message if applicable.
 *
 * @param iframe the iframe element we are attempting to load a document in.
 * @param timer the timer which calls the checkIFrameLoaded function.
 */
function checkIFrameLoaded(iframe: HTMLIFrameElement, timer: number): void {
    if (cancel) {
        clearTimeout(timer);
        timer = null;
        return;
    }

    const iframeDoc =  iframe.contentDocument || iframe.contentWindow.document;
    iframeDocReadyState = iframeDoc.readyState;
    diagnostics.success = iframeDocReadyState === "complete";

    if (diagnostics.success) {
        diagnostics.details = resources.Iframe_success;
        endIFrameTest(timer);
    }
}

/**
 * If iframe doc was not successfully loaded,
 * updates diagnostic data object with failure message.
 *
 * @param testSuccessful boolean flag indicating whether loading was successful during polling.
 * @param iframe the iframe element we are attempting to load a document in.
 * @param timer the timer which calls the checkIFrameLoaded function.
 */
function checkIFrameLoadFailure(testSuccessful: boolean, timer: number) {
    if (!testSuccessful) {
        diagnostics.details = resources.Iframe_failure.replace("{0}", iframeDocReadyState);
        endIFrameTest(timer);
    }
}

/** Clears timer and ends the test */
function endIFrameTest(timer: number) {
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }

    if (cancel) {
        return;
    }
    endTest();
}

/** Initializes an iFrame and calls function using timer to check success */
function checkiFrame(): void {
    try {
        const iframe = document.createElement("iframe") as HTMLIFrameElement;
        iframe.style.display = "none";
        iframe.src = "./selfhelp";
        const iFrameDiv = document.getElementById("shdid-hidden-iFrame");
        iFrameDiv.appendChild(iframe);
        if (cancel) {
            return;
        }
        const timer = setInterval(() => checkIFrameLoaded(iframe, timer), 100) as unknown as number;
        setTimeout(() => { clearInterval(timer); checkIFrameLoadFailure(diagnostics.success, timer); }, 10000);
    } catch {
        diagnostics.success = false;
        diagnostics.details = resources.Iframe_error;
        endTest();
    }
}

/** Triggers beginning of test and update of DOM. */
export function startTest(): void {
    diagnostics = { success: null, details: null };
    testRan = false;
    DomHelper.displayStatusIcon(key, statusIconVals.inProgress);
    checkiFrame();
}
